import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
import sections from 'src/styles/sections';
import breakpointsFunc from 'src/styles/breakpointsFunc';
export const useSubmeterBillModalStyles = makeStyles(_objectSpread(_objectSpread({}, sections), {}, {
  emptyForm: {
    padding: '16px 24px 24px 24px'
  },
  groupWrapper: {
    '&:not(:last-child)': {
      marginBottom: '24px'
    },
    '& .MuiFormControl-root': {
      display: 'flex'
    },
    '& .react-datepicker-wrapper': {
      display: 'block'
    }
  },
  groupWrapperContent: {
    display: 'flex',
    [breakpointsFunc.breakpoints.down('lg')]: {
      flexWrap: 'wrap'
    }
  },
  uploadSection: {
    padding: '16px 24px 24px 24px'
  },
  errorsSection: {
    // marginTop: '16px',
    paddingTop: '16px',
    backgroundColor: palette.shades[100]
  },
  errorTitle: {
    padding: '16px'
  }
}));